// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"3120b655","202":"79edc201","396":"867a7e94","728":"7d5c66e3","808":"bcc82d73","929":"fd59fb3b"}[chunkId] + ".chunk.js";
};